import styled from 'styled-components';
import { H3, SvgIcon, Span } from '../JetCard.style';
import { vw } from 'components/common/Common';
import Header from 'pages/charterQuote/components/contents/Header';

const Container = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${vw(60)};
  article {
    width: 100%;
    text-align: left;
    padding: ${vw(100)};
  }
`;

const Features = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${vw(20)};
`;

const Feature = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: ${vw(20)};
  text-align: center;
  background: #f4f6fc;
  padding: ${vw(16)} 0;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleSpan = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #050a30;
  line-height: 1.3;
  margin: 0;
`;

const FeatureList = [
  {
    h3Title: 'No Blackout Dates',
    spanTitle: (
      <Span>
        Fly whenever you desire, with <br />
        guaranteed availability
      </Span>
    ),
    alt: 'No Blackout Dates',
  },
  {
    h3Title: 'No Monthly Fees',
    spanTitle: (
      <Span>
        Private jet access without the <br />
        recurring charges.
      </Span>
    ),
    alt: 'No Monthly Fees',
  },
  {
    h3Title: 'Fixed Hourly Rates',
    spanTitle: (
      <Span>
        Predictable costs for <br />
        seamless budgeting.
      </Span>
    ),
    alt: 'Fixed Hourly Rates',
  },
  {
    h3Title: 'Domestic and International',
    spanTitle: (
      <Span>
        Reach destinations worldwide <br />
        with ease.
      </Span>
    ),
    alt: 'Domestic and International',
  },
];

const Introduce = () => {
  return (
    <Container>
      <Header
        title={
          <>
            Introducing our
            <br />
            Prepaid Jet Card
          </>
        }
        desc={[
          'Start with a 10-hour jet card, offering you the autonomy to fly at your convenience. As you embark on each flight, the hours are deducted from your account. Easily top up with additional hours in blocks of 10, 20, 30, 40, or 50 so your travel arrangements are always under your control.',
        ]}
      />
      <Features>
        {FeatureList.map((item, index) => (
          <Feature key={index}>
            <SvgIcon src={`imgs/svg/jetCard/introduce-${index}.svg`} $size={96} alt={item.alt} />
            <Title>
              <H3 $fontSize={'20px'}>{item.h3Title}</H3>
              <TitleSpan>{item.spanTitle}</TitleSpan>
            </Title>
          </Feature>
        ))}
      </Features>
    </Container>
  );
};

export default Introduce;
